// src/AppContent.jsx
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";
import { Box, CircularProgress } from "@mui/material";
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import RoleRoute from "./routes/RoleRoute";
import LoginForm from "./components/LoginForm";
import Dashboard from "./pages/Dashboard";
import AdminPanel from "./pages/AdminPanel";
import Unauthorized from "./pages/Unauthorized";
import MainLayout from "./layouts/MainLayout";
import PublicLayout from "./layouts/PublicLayout";
import PatientsPage from "./pages/user/PatientsPage";
import GuestLoginPage from "./pages/guest/GuestLoginPage";
import GuestLoginFailPage from "./pages/guest/GuestLoginFailPage";
import QrPage from "./pages/guest/QrPage";
import ThankYouPage from "./pages/guest/ThankYouPage";
import InventoryPage from "./pages/user/InventoryPage";
import MaintenancePage from "./pages/user/MaintenancePage";
import SettingsPage from "./pages/user/SettingsPage";
import AppointmentConfirmPage from "./pages/guest/AppointmentConfirmPage";
import PrescriptionPage from "./pages/guest/PrescriptionPage";
import PublicDocumentLayout from "./layouts/PublicDocumentLayout";
import InvoicePage from "./pages/guest/InvoicePage";
import MedicalHistoryPage from "./pages/user/MedicalHistoryPage";
import ReportsPage from "./pages/user/ReportsPage";
import UserInvitePage from "./pages/guest/UserInvitePage";

function AppContent() {
  const { loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        {/* unauthenticated users */}
        <Route element={<PublicLayout />}>
            <Route
                path="/login"
                element={
                <PublicRoute>
                    <LoginForm />
                </PublicRoute>
                }
            />
            <Route
                path="/login-guest"
                element={
                <PublicRoute>
                    <GuestLoginPage />
                </PublicRoute>
                }
            />
            <Route
                path="/login-fail"
                element={
                <PublicRoute>
                    <GuestLoginFailPage />
                </PublicRoute>
                }
            />
            <Route
                path="/thank-you"
                element={
                    <PublicRoute>
                    <ThankYouPage />
                    </PublicRoute>
                }
            />
            <Route
                path="/appointments/confirm/:code"
                element={
                    <PublicRoute>
                    <AppointmentConfirmPage />
                    </PublicRoute>
                }
            />

        </Route>
        <Route element={<PublicDocumentLayout />}>
          <Route
            path="/prescription/:code"
            element={
                <PrescriptionPage />
            }
          />
        </Route>
        <Route element={<PublicDocumentLayout />}>
          <Route
            path="/invoice/:id/:invoiceNumber"
            element={
                <InvoicePage />
            }
          />
        </Route>
        <Route element={<PublicLayout />}>
          <Route
            path="/invites/activate/:hash"
            element={
                <UserInvitePage />
            }
          />
        </Route>
            
        {/* all authenticated users */}
        <Route element={<MainLayout />}>
            <Route
                path="/unauthorized"
                element={
                    <Unauthorized />
                }
            />
            <Route
                path="/dashboard"
                element={
                <PrivateRoute>
                    <Dashboard />
                </PrivateRoute>
                }
            />
            {/* role specific */}
            <Route 
                path="/qr-page" 
                element={ 
                    <RoleRoute allowedRoles={["guest"]}>
                        <QrPage />
                    </RoleRoute>
                } 
            />
            <Route 
                path="/admin" 
                element={ 
                    <RoleRoute allowedRoles={["admin"]}>
                        <AdminPanel />
                    </RoleRoute>
                } 
            />
            <Route 
                path="/history" 
                element={ 
                    <RoleRoute allowedRoles={["user"]}>
                        <MedicalHistoryPage />
                    </RoleRoute>
                } 
            />
            <Route 
                path="/patients" 
                element={ 
                    <RoleRoute allowedRoles={["user"]}>
                        <PatientsPage />
                    </RoleRoute>
                } 
            />
            <Route 
                path="/inventory" 
                element={ 
                    <RoleRoute allowedRoles={["user"]}>
                        <InventoryPage />
                    </RoleRoute>
                } 
            />
            <Route 
                path="/inventory/items" 
                element={ 
                    <RoleRoute allowedRoles={["user"]}>
                        <InventoryPage />
                    </RoleRoute>
                } 
            />
            <Route 
                path="/inventory/items/:id" 
                element={ 
                    <RoleRoute allowedRoles={["user"]}>
                        <InventoryPage />
                    </RoleRoute>
                } 
            />
            <Route 
                path="/reports" 
                element={ 
                    <RoleRoute allowedRoles={["user"]}>
                        <ReportsPage />
                    </RoleRoute>
                } 
            />
            <Route 
                path="/maintenance" 
                element={ 
                    <RoleRoute allowedRoles={["user"]}>
                        <MaintenancePage />
                    </RoleRoute>
                } 
            />
            <Route 
                path="/settings" 
                element={ 
                    <RoleRoute allowedRoles={["user"]}>
                        <SettingsPage />
                    </RoleRoute>
                } 
            />
        </Route>
    </Routes>
  );
}

export default AppContent;
